export default "__VITE_ASSET__CK0e9Qdn__"